// @ts-nocheck
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
// import ProductBrand, { ProductBrandStyles } from "@insite/content-library/Components/ProductBrand"; // Starter Custom Code
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import * as React from "react";
import { css } from "styled-components";

/* Starter Custom Code - Start */
import ProductBrand, { ProductBrandStyles } from "@store/Overrides/Components/ProductBrand";
import { typographyTitleStyles } from "@store/Themes/common/mixins/typography";
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
import { pxToRem, pxToRemArray } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { spacingStyles } from "@toolkit/Themes/common/mixins";
/* Starter Custom Code - End */

/* Store Custom Code - Start */
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
/* Store Custom Code - End */

type Props = WidgetProps & HasProduct;

export interface ProductDetailsPageTitleStyles {
    container?: GridContainerProps;
    brandGridItem?: GridItemProps;
    brandStyles?: ProductBrandStyles;
    titleGridItem?: GridItemProps;
    titleText?: TypographyProps;
    obsoleteGridItem?: GridItemProps; // Store Custom Code
    obsoleteWrapper?: InjectableCss; // Store Custom Code
}

export const pageTitleStyles: ProductDetailsPageTitleStyles = {
    container: {
        gap: 0,
        css: css`
            ${spacingStyles(null, pxToRem(12))}
        `,
    },
    brandGridItem: {
        width: 12,
    },
    brandStyles: {
        wrapper: {
            css: css`
                margin-bottom: ${pxToRem(8)};
            `,
        },
        logoImage: {
            css: css`
                margin-bottom: ${pxToRem(4)};
            `,
        },
    },
    titleGridItem: {
        width: 12,
    },
    titleText: {
        forwardAs: "h1",
        // Store Custom Code
        css: css`
            ${breakpointValues(pxToRemArray([26, 26, 26, 34, 34]), "font-size")}
            font-weight: ${x => x.theme.design.typography.weight.base};
        `,
    },
    // Store Custom Code
    obsoleteGridItem: {
        width: 12,
    },
    obsoleteWrapper: {
        css: css`
            color: ${getColor("warning.main")};
            border: 1px solid ${getColor("warning.main")};
            padding: ${pxToRem(14)};
            margin-bottom: 1em;
        `,
    },
};

const styles = pageTitleStyles;

const ProductDetailsPageTitle: React.FC<Props> = ({ product }) => {
    return (
        <GridContainer {...styles.container}>
            {/* Store Custom Code - Start */}
            {product.properties?.isObsolete && (
                <GridItem {...styles.obsoleteGridItem}>
                    <StyledWrapper {...styles.obsoleteWrapper}>
                        <Typography data-test-selector="productDetails_obsoleteWarning">
                            <span>{translate("Store_ProductDetail_Obsolete_Warning")}</span>
                        </Typography>
                    </StyledWrapper>
                </GridItem>
            )}
            {/* Store Custom Code - End */}
            {product.brand && (
                <GridItem {...styles.brandGridItem}>
                    <ProductBrand brand={product.brand} showLogo={true} extendedStyles={styles.brandStyles} />
                </GridItem>
            )}
            <GridItem {...styles.titleGridItem}>
                <Typography {...styles.titleText} data-test-selector="productDetails_productDescription">
                    {product.productTitle}
                </Typography>
            </GridItem>
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(ProductDetailsPageTitle),
    definition: {
        displayName: "Page Title",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
